import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@ifit/themes/withTheme';

export const Rating = ({ rating, themeClass }) => (
  <div className={`rating ${themeClass}`}>
    <span className="card-icon">S</span>
    <span className="value">{`${Number(
      Math.round(rating.average * 10) / 10
    ).toLocaleString()}`}</span>
  </div>
);

Rating.propTypes = {
  rating: PropTypes.shape({
    average: PropTypes.number,
  }),
  themeClass: PropTypes.string,
};

Rating.defaultProps = {
  rating: {
    average: 0,
  },
};

Rating.displayName = 'Card.Rating';

export default withTheme(Rating);
